import { screenMdMin } from '@utils/match-media';

export default class CategorySlider {
    constructor($el) {
        this.$el = $el;
    }

    init() {
        this.setupListeners();
        this.toggleSlider();
    }

    setupListeners() {
        screenMdMin.addEventListener('change', () => this.toggleSlider());
    }

    toggleSlider() {
        if(screenMdMin.matches) {
            this.$el.slick({
                infinite: false,
                rows: 0,
                slidesToShow: 5,
            });
        } else if(this.$el.hasClass('slick-initialized')) {
            this.$el.slick('unslick');
        }
    }
}

$(() => {
    const rootEls = document.querySelectorAll('.js-category-slider');
    rootEls.forEach((el) => {
        const $el = $(el);
        const slider = new CategorySlider($el);
        slider.init();
    });
});
